import React from "react";
import PageBanner from './PageBanner';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';
import AboutSection from './AboutSection';

const Home = () => {
  console.log("Home rendered");
  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-2 d-none d-md-block">
          <LeftSection />
        </div>
        <div className="col-8">
          <SearchbarSection />
          <PageBanner />
          <AboutSection />
        </div>
        <div className="col-2 d-block">
          <RightSection />
        </div>
      </div>
    </div>
  );
};

export default Home;